(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7001],{

/***/ 2679:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guide",
      function () {
        return __webpack_require__(1729);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_guide; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/modules/hooks/useTranslation.ts + 44 modules
var useTranslation = __webpack_require__(1306);
// EXTERNAL MODULE: ./src/feature/guide/index.tsx
var guide = __webpack_require__(7045);
// EXTERNAL MODULE: ./src/styles/guide/useGuide.module.scss
var useGuide_module = __webpack_require__(2699);
var useGuide_module_default = /*#__PURE__*/__webpack_require__.n(useGuide_module);
// EXTERNAL MODULE: ./src/components/MediaQuery.tsx
var MediaQuery = __webpack_require__(7620);
;// CONCATENATED MODULE: ./src/feature/guide/SetType.tsx





var SetType = function(param) {
    var type = param.type, setType = param.setType;
    var t = (0,useTranslation/* default */.Z)("guide").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: (useGuide_module_default()).type_list,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "".concat((useGuide_module_default()).type_item, " ").concat(type === "STS" ? (useGuide_module_default()).active : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    onClick: function() {
                        return setType("STS");
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQuery.PC, {
                            children: t("STS")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQuery/* Mobile */.i, {
                            children: "STS"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "".concat((useGuide_module_default()).type_item, " ").concat(type === "TTS" ? (useGuide_module_default()).active : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    onClick: function() {
                        return setType("TTS");
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQuery.PC, {
                            children: t("TTS")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQuery/* Mobile */.i, {
                            children: "TTS"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var guide_SetType = (SetType);

;// CONCATENATED MODULE: ./pages/guide/index.tsx







var Guide = function() {
    var t = (0,useTranslation/* default */.Z)("guide").t;
    var ref = (0,react.useState)("STS"), type = ref[0], setType = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: t("title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: t("title")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "container",
                className: (useGuide_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (useGuide_module_default()).title_area,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: (useGuide_module_default()).title,
                                children: "Studio Guide"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(guide_SetType, {
                                type: type,
                                setType: setType
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(guide/* default */.Z, {
                        type: type
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages_guide = (Guide);


/***/ }),

/***/ 7045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4480);
/* harmony import */ var _modules_hooks_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1306);
/* harmony import */ var _modules_state_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7926);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9094);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var GuideContents = function(param) {
    var type = param.type;
    var ref = (0,_modules_hooks_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("guide"), t = ref.t, locale = ref.locale;
    var isMobileSize = (0,recoil__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(_modules_state_common__WEBPACK_IMPORTED_MODULE_4__/* .IsMobileSize */ .h_);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1), step = ref1[0], setStep = ref1[1];
    var handleStepChange = function(index) {
        return setStep(index);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().guide_area),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().step_list),
                children: [
                    t("titleList")[type].map(function(item, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "".concat((_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().step_item), " ").concat(index + 1 === step ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active) : ""),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                type: "button",
                                onClick: function() {
                                    return handleStepChange(index + 1);
                                },
                                children: [
                                    index + 1,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().pc),
                                        children: [
                                            ". ",
                                            item
                                        ]
                                    })
                                ]
                            })
                        }, index);
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                        style: {
                            left: "".concat(!isMobileSize ? "calc((100% - 160px) / 5 * ".concat(step - 1, " + ").concat((step - 1) * 40, "px)") : "calc((100% - 56px) / 5 * ".concat(step - 1, " + ").concat((step - 1) * 14, "px)"), " ")
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content_list),
                children: t("contentList")[type].map(function(item, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        className: "".concat((_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content_item), " ").concat(step === index + 1 ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active) : ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().left_col),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().step),
                                        children: [
                                            "Step ",
                                            index + 1,
                                            "."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().title_content),
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().text_content),
                                        children: item.text
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/images/guide/".concat(type, "/").concat(index + 1, "_").concat(locale, ".webp"),
                                alt: "",
                                loading: "eager"
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GuideContents);


/***/ }),

/***/ 9094:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pc":"styles_pc__nZ_Rd","mobile":"styles_mobile__FxV24","hide":"styles_hide__kDqZw","guide_area":"styles_guide_area__HeGa0","step_list":"styles_step_list__BHKg0","step_item":"styles_step_item__7hfIz","active":"styles_active__qoFcw","content_list":"styles_content_list__TlaTJ","content_item":"styles_content_item__xu4s8","left_col":"styles_left_col__fh1_4","step":"styles_step__vEB6q","title_content":"styles_title_content__c13ic","text_content":"styles_text_content__E16Pv"};

/***/ }),

/***/ 2699:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pc":"useGuide_pc__iaq_x","mobile":"useGuide_mobile__QmgIt","hide":"useGuide_hide___5PXd","container":"useGuide_container__G_rmj","title_area":"useGuide_title_area__u2eaM","title":"useGuide_title__EPAR7","type_list":"useGuide_type_list__HMvZ8","type_item":"useGuide_type_item__Q8g_C","active":"useGuide_active__yszcA"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(2679); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);